import React, { useState } from "react";
import { useTranslation } from "react-i18next";
import { API_URL } from "../../../../config";
import { Modal, ModalBody, ModalHeader } from "reactstrap";

const LearningPlanForm = ({selectedFormId,data,selectedClientDetails}) => {
  const { t } = useTranslation();

  const initialFormData = {
    Client_Name: selectedClientDetails ? `${selectedClientDetails.firstname} ${selectedClientDetails.lastname}` : "",
    Original_or_Revised: "",
    Session_Num: "",
    Date: "",
    Practitioner_Name: "",
    Email: "",
    Overall_learning_objectives: "",
    Breathing_behaviors: "",
    Principal_symptoms: "",
    Faulty_beliefs: "",
    Habit_triggers: "",
    Motivations_and_emotions: "",
    En_vivo_work: "",
    Specific_learning_protocols: "",
  }
  const [formData, setFormData] = useState(data?data:initialFormData);

  const handleInputChange = (e) => {
    const { name, value, type } = e.target;

    if (type === "checkbox") {
      // toggle checkbox selection so only one (Original/Revised) can be checked
      setFormData((prev) => ({
        ...prev,
        Original_or_Revised: value === prev.Original_or_Revised ? "" : value,
      }));
    } else {
      setFormData((prev) => ({
        ...prev,
        [name]: value,
      }));
    }
  };

 const [successModal, setsuccessModal] = useState(false);
    const successToggleModal = () => setsuccessModal(!successModal);
  const [loading, setLoading] = useState(false);
const handleSubmit = (e) => {
  e.preventDefault();
  
  
  const userId = localStorage.getItem("user_id");
  const selectedClient = localStorage.getItem("selectedClient");
  const accessToken = localStorage.getItem("accessToken");

  const client_id = selectedClient === "null" ? userId : selectedClient;

  // Start loader
  setLoading(true);



  // Prepare payload (no need to stringify form_data here)
  const payload = {
    client_id: client_id,
    form_id: selectedFormId, // Ensure this variable is defined
    form_data: JSON.stringify(formData),
    session_id:  localStorage.getItem("selectedSession") || null,
  };

  console.log("📤 Sending form payload test:", payload);

  fetch(API_URL + "/forms/trainer/form-submit", {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      "x-access-token": accessToken,
    },
    body: JSON.stringify(payload),
  })
    .then((res) => res.json())
    .then((resp) => {
      console.log("✅ Response:", resp);
      if (resp.status) {
        successToggleModal();
        setFormData(initialFormData);
      } else {
        console.error("❌ Upload failed:", resp.message);
        console.log("Upload failed: " + resp.message);
      }
    })
    .catch((err) => {
      console.error("⚠️ Error submitting form:", err);
      console.log("Something went wrong while submitting the form.");
    })
    .finally(() => {
      setLoading(false);
    });
};

  const inputStyle = {
    backgroundColor: "#f1f4ff",
    borderBottom: "2px solid #444",
    borderTop: "none",
    borderLeft: "none",
    borderRight: "none",
    outline: "none",
    height: "30px",
  };

  const textareaStyle = {
    border: "1px solid black",
    height: "80px",
    width: "100%",
    backgroundColor: "#f1f4ff",
    outline: "none",
    paddingLeft:"5px",
    paddingRight:"5px"
  };

  return (
    <div
      style={{
        fontFamily: "Arial, sans-serif",
        maxWidth: "1200px",
        margin: "0 auto",
        marginTop: "20px",
        padding: !data?"20px":"10px",
      border: !data && "1px solid #ccc",
      }}
    >
      <h1
        style={{
           fontSize: "22px",
        fontWeight: "bold",
        color: "#800080",
        textAlign: "center",
        marginBottom: "16px",
        }}
      >
        LEARNING PLAN
      </h1>

      {/* Client Info */}
      <div
        style={{
          marginBottom: "15px",
          display: "flex",
          alignItems: "flex-end",
          flexWrap: "wrap",
          gap: "10px",
        }}
      >
        <span>Client Name:</span>
        <input
          name="Client_Name"
          value={formData.Client_Name}
          disabled={Boolean(selectedClientDetails)}
          onChange={handleInputChange}
          style={{ ...inputStyle, width: "340px" }}
        />

        <span style={{ display: "flex", alignItems: "center", gap: "10px" }}>
          <label style={{ cursor: "pointer" }}>
            <input
              type="checkbox"
              value="Original"
              checked={formData.Original_or_Revised === "Original"}
              onChange={handleInputChange}
              style={{ cursor: "pointer", marginRight: "5px" }}
            />
            Original
          </label>
          <label style={{ cursor: "pointer" }}>
            <input
              type="checkbox"
              value="Revised"
              checked={formData.Original_or_Revised === "Revised"}
              onChange={handleInputChange}
              style={{ cursor: "pointer", marginRight: "5px" }}
            />
            Revised
          </label>
        </span>

        <span>Session #</span>
        <input
          name="Session_Num"
          value={formData.Session_Num}
          onChange={handleInputChange}
          style={{ ...inputStyle, width: "50px" }}
        />

        <span>Date:</span>
        <input
          name="Date"
          value={formData.Date}
          onChange={handleInputChange}
          style={{ ...inputStyle, width: "150px" }}
        />
      </div>

      {/* Practitioner Info */}
      <div
        style={{
          marginBottom: "15px",
          display: "flex",
          alignItems: "flex-end",
          flexWrap: "wrap",
          gap: "10px",
        }}
      >
        <span>Practitioner Name:</span>
        <input
          name="Practitioner_Name"
          value={formData.Practitioner_Name}
          onChange={handleInputChange}
          style={{ ...inputStyle, width: "370px" }}
        />
        <span>Email:</span>
        <input
          name="Email"
          value={formData.Email}
          onChange={handleInputChange}
          style={{ ...inputStyle, width: "350px" }}
        />
      </div>

      {/* Textareas */}
      {[
        { label: "Overall learning objectives...", name: "Overall_learning_objectives" },
        {
          label:
            "Breathing behaviors to be learned/unlearned (e.g., forced exhaling)...",
          name: "Breathing_behaviors",
        },
        {
          label: "Principal symptoms and/or deficits to be ameliorated...",
          name: "Principal_symptoms",
        },
        {
          label:
            "Faulty beliefs about BREATHING and/or misguided INTERPRETATIONS of symptoms to be addressed...",
          name: "Faulty_beliefs",
        },
        {
          label:
            "Habit triggers (e.g., memories) to be addressed and in what contexts (e.g., while at work)...",
          name: "Habit_triggers",
        },
        {
          label:
            "Motivations, reinforcements, and emotions associated with breathing to be addressed...",
          name: "Motivations_and_emotions",
        },
        { label: "En vivo work to be done in the field...", name: "En_vivo_work" },
        {
          label:
            "Specific learning protocols to be used during learning sessions (e.g., negative practice: chest vs. diaphragmatic breathing)...",
          name: "Specific_learning_protocols",
        },
      ].map((field, idx) => (
        <div key={idx} style={{ marginBottom: "15px" }}>
          <div>{field.label}</div>
          <textarea
            name={field.name}
            value={formData[field.name]}
            onChange={handleInputChange}
            style={textareaStyle}
          />
        </div>
      ))}

      {/* Submit */}
     
        {!data &&  <div className="client-submit-btn">
        <button type="button" onClick={handleSubmit}>
          {loading?t("Submitting..."):t("Submit")}
        </button>
      </div>}
       <Modal
                                                              isOpen={successModal}
                                                              toggle={successToggleModal}
                                                              className="connect-box"
                                                              centered={true}
                                                            >
                                                              <ModalHeader toggle={successToggleModal}>
                                                                <span className="ml-1 roititle font-weight-bold">
                                                                  Successfull
                                                                </span>
                                                              </ModalHeader>
                                                              <ModalBody>
                                                                <div className="modal-p">
                                                                  <p>Trainer form has been submitted successfully.</p>
                                                                </div>
                                                              </ModalBody>
                                                            </Modal>
    </div>
  );
};

export default LearningPlanForm;
